import { render, staticRenderFns } from "./CorrectionsPage.vue?vue&type=template&id=14b83f4e&"
import script from "./CorrectionsPage.vue?vue&type=script&lang=js&"
export * from "./CorrectionsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports